// The hero's right-hand proof: Revetra's verdict gauge sitting on top
// of a sample denial letter. The choreographed entrance (letter settles,
// stamp punches in, the flagged sentence underlines, the verdict card
// rises, the confidence chip drops, the gauge fills last) lives in
// `styles/landing.css` under the `lp-*` classes; this component only
// supplies the markup it animates.
export function VerdictProof() {
  return (
    <aside className="relative z-[2]" aria-label="What Revetra returns">
      <div className="relative pl-9 max-[980px]:max-w-[480px] max-[980px]:pl-0">
        <span className="lp-chip absolute left-3.5 top-[-12px] z-[4] rounded-full bg-ink px-3 py-[5px] text-[10px] font-medium uppercase tracking-[0.14em] text-parchment">
          Free analysis
        </span>

        <article className="lp-letter relative max-w-[440px] rounded-md border-[0.5px] border-line bg-surface px-7 pb-[22px] pt-6 shadow-[0_1px_0_rgba(0,0,0,0.08),0_12px_32px_-16px_rgba(26,26,26,0.18)]">
          <header className="mb-3.5 flex items-center justify-between">
            <div className="font-serif text-[13px] font-medium tracking-[-0.005em] text-ink">
              <small className="mb-0.5 block font-sans text-[10px] font-medium uppercase tracking-[0.14em] text-ink-hint">
                Carrier letter
              </small>
              Anthem Blue Cross PPO
            </div>
            <span className="lp-stamp rounded border-[1.5px] border-brick px-2.5 py-1 font-sans text-[10px] font-semibold uppercase tracking-[0.14em] text-brick">
              Denied
            </span>
          </header>

          <div className="font-serif text-[13px] leading-[1.6] text-ink-soft">
            <p className="mb-2.5">
              <strong className="font-medium text-ink">Re: Claim 4421-A · Lumbar MRI</strong>
            </p>
            <p className="mb-2.5">
              After review of the submitted documentation, the requested service has not been
              authorized.
            </p>
            <p className="lp-quote my-2 border-l-2 border-brick py-1 pl-3 italic text-ink">
              &ldquo;Duration of symptoms inadequate to justify advanced imaging under Policy
              CG-MED-58 §4.2.&rdquo;
            </p>
            <p className="mt-3.5 text-[11.5px] text-ink-hint">
              — Utilization Review · May 14, 2026
            </p>
          </div>
        </article>

        <div
          className="lp-verdict absolute bottom-[-32px] right-[-8px] z-[3] w-[200px] rounded-md border-[0.5px] border-line bg-surface px-5 py-[18px] shadow-[0_14px_38px_-14px_rgba(26,26,26,0.18)]"
          aria-label="Revetra's verdict"
        >
          <header className="mb-3 flex items-center justify-between">
            <span className="text-[9.5px] font-medium uppercase tracking-[0.14em] text-ink-hint">
              Revetra · Verdict
            </span>
            <span className="pill-verified text-[9.5px]">Strong case</span>
          </header>

          <div className="flex items-center gap-3.5">
            <div className="relative h-16 w-16 flex-shrink-0">
              <svg viewBox="0 0 80 80" className="h-full w-full -rotate-90">
                <circle className="lp-gauge-track" cx="40" cy="40" r="34" />
                <circle className="lp-gauge-progress" cx="40" cy="40" r="34" />
              </svg>
              <div className="absolute inset-0 flex items-center justify-center font-serif text-[22px] font-medium tracking-[-0.02em] text-ink">
                75<span className="text-[14px] text-ink-ghost">%</span>
              </div>
            </div>
            <div>
              <div className="font-serif text-[15px] font-medium leading-[1.3] tracking-[-0.005em] text-ink">
                Likely to overturn
              </div>
              <div className="mt-1 text-[11px] leading-[1.5] text-ink-muted">
                Chart documents 6+ weeks conservative care — ACR criteria met.
              </div>
            </div>
          </div>
        </div>
      </div>
    </aside>
  );
}
